import React from "react";

/**
 * BrandLogo — LancerCity logo (image-based).
 *   /logo-ar.png  — Arabic wordmark + hat
 *   /logo-en.png  — English wordmark + hat
 *
 * Props:
 *   lang       - "ar" (default) | "en"
 *   markHeight - logo height in px (default 42)
 *   inverted   - true for white logo on dark bg
 *   markOnly   - render only the hat (SVG)
 *   color      - hat color when markOnly (default #0D7377)
 */
export default function BrandLogo({
  lang = "ar",
  markHeight = 42,
  inverted = false,
  markOnly = false,
  color,
}) {
  const isAr = lang === "ar";

  if (markOnly) {
    const fill = inverted ? "#FFFFFF" : (color || "#0D7377");
    const w = markHeight * (120 / 96);
    return (
      <svg viewBox="0 0 120 96" width={w} height={markHeight} xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Lancer City" style={{ display: "block", flex: "none" }}>
        <path fill={fill} d="M13 66 C13 59 22 57 31 60 C45 64 75 64 89 60 C98 57 107 59 107 66 C107 75 88 81 60 81 C32 81 13 75 13 66 Z" />
        <path fill={fill} d="M33 62 C33 33 45 18 60 18 C75 18 87 33 87 62 C76 57 44 57 33 62 Z" />
      </svg>
    );
  }

  const h = Math.round(markHeight * 1.05);
  return (
    <span className="brand-logo" dir={isAr ? "rtl" : "ltr"} style={{ display: "inline-flex", alignItems: "center", lineHeight: 1 }}>
      <img
        src={isAr ? "/logo-ar.png" : "/logo-en.png"}
        alt={isAr ? "لانسر سيتي" : "LancerCity"}
        height={h}
        style={{
          height: `${h}px`,
          width: "auto",
          display: "block",
          filter: inverted ? "brightness(0) invert(1)" : "none",
        }}
      />
    </span>
  );
}
